import { pxToRem } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const CartLineItemDeleteFiller = styled.div`
  width: ${pxToRem(30)};
`;
